<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('promotion.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-date-picker
              v-model="start_date"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="fetchData()"
              v-tooltip="$t('promotion.startDate')"
            ></a-date-picker>
          </div>
          <div class="d-flex">
            <ts-input
              v-tooltip="$t('promotion.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'promo_type.promo_type',
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.promotion_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.promo_start_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.promo_end_date }}</td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <!-- <a-popconfirm
								placement="leftTop"
								:title="$t('are_you_sure_to_delete')"
								:ok-text="$t('yes')"
								:cancel-text="$t('no')"
								@confirm="deleteRecord(record)"
							>
								<a href="#" :disabled="record._deleting">
									<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
									<i class="fa fa-trash text-red" v-else></i>
								</a>
							</a-popconfirm> -->
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'promotion',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('promotion/resource', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.promotion.resource.search
      },
      set(newValue) {
        this.$store.commit('promotion/resource/SET_SEARCH', newValue)
        this.$store.commit('promotion/resource/RESET_CURRENT_PAGE')
      },
    },
    start_date: {
      get() {
        return this.$store.state.promotion.resource.startDate
      },
      set(newValue) {
        this.$store.commit('promotion/resource/SET_DATE_START', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('promotion.eventName') },
        { name: this.$t('promotion.startDate') },
        { name: this.$t('promotion.endDate') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'promotion-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('promotion/resource/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      var name_tem = 'discount-edit'
      switch (record.promo_type_id) {
        case 1:
          name_tem = 'discount-edit'
          break
        case 2:
          name_tem = 'free-item-per-amount-edit'
          break
        case 3:
          name_tem = 'free-coin-edit'
          break
        case 4:
          name_tem = 'buy-item-free-item-edit'
          break
      }
      this.$router.push({
        name: name_tem,
        params: {
          id: record.promotion_id,
        },
      })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>